import ListRetailers from "../../../../components/@users/retailers/ListRetailers";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function RetailersPage() {

    return (
        <ListRetailers 
            routeType={routeTypes.admin}
        />
    )
}       